import React from 'react';
import { Typography } from '@mui/material';

/** The heading over one part of a dialog ("People with access", "Match species not on the list"). */
const PartTitle = ({ children }) => (
  <Typography variant="subtitle2" component="h3" sx={{ mb: 1.5 }}>{children}</Typography>
);

export default PartTitle;
